"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => createTree
});
module.exports = __toCommonJS(src_exports);

// src/services/giving-tree/calculator.ts
var import_formula_pro = __toESM(require("@jspreadsheet/formula-pro"));

// src/services/giving-tree/formula-utility.ts
var FormulaUtility = {
  NEWLINE_REGEX: new RegExp(`\\n`, "g"),
  AND_OR_REGEX: /(.*if\s*\()([^,]+)(or|and)+([^,]+)(,[^,]+,[^)]+\).*)/,
  AND_OPERATOR_REGEX: new RegExp(`&Operate`, "g"),
  OR_OPERATOR_REGEX: new RegExp(`\\|Operate`, "g"),
  removeLinebreaks: function(definition) {
    return definition.replace(this.NEWLINE_REGEX, " ");
  },
  convertNonLeadingZeroDecimals: function(definition) {
    return definition.replace(/(\D)(\.\d+)/g, "$10$2");
  },
  convertParameterNumberToLetter: function(definition, parameterIndex, letter) {
    const regexPattern = new RegExp(`\\{${parameterIndex}\\}`, "g");
    return definition.replace(regexPattern, letter);
  },
  numberToLetter: function(num) {
    const parsedInt = parseInt(num);
    if (parsedInt < 26) {
      return String.fromCharCode(97 + parsedInt);
    } else {
      const firstLetterNum = Math.floor(parsedInt / 26);
      const secondLetterNum = parsedInt - 26 * firstLetterNum;
      return String.fromCharCode(97 + firstLetterNum) + String.fromCharCode(97 + secondLetterNum);
    }
  },
  convertAndOrFormulas: function(definition) {
    let result;
    do {
      result = this.convertOneAndOrFormula(definition);
      if (result) {
        definition = result;
      }
    } while (result);
    definition = definition.replace(this.AND_OPERATOR_REGEX, "and");
    definition = definition.replace(this.OR_OPERATOR_REGEX, "or");
    return definition;
  },
  convertOneAndOrFormula: function(definition) {
    const matches = this.AND_OR_REGEX.exec(definition);
    if (!matches) {
      return null;
    }
    const a = matches[1];
    const b = matches[5];
    const operator = matches[3];
    const replaceOperator = operator === "and" ? "&Operate" : "|Operate";
    const operator_a = matches[2];
    const operator_b = matches[4];
    return `${a}${replaceOperator}(${operator_a},${operator_b})${b}`;
  }
};

// src/services/giving-tree/and-or-formula-utility.ts
var AndOrFormulaUtility = {
  AND_OPERATOR_REGEX: new RegExp(`&Operate`, "g"),
  OR_OPERATOR_REGEX: new RegExp(`\\|Operate`, "g"),
  update: function(input) {
    let updated = this.updateAndOr(input, " and ", "&Operate");
    updated = this.updateAndOr(updated, " or ", "|Operate");
    updated = updated.replace(this.AND_OPERATOR_REGEX, "and");
    updated = updated.replace(this.OR_OPERATOR_REGEX, "or");
    return updated;
  },
  updateAndOr: function(input, word, replace) {
    let replaced = input;
    do {
      replaced = this.updateAndOrInstance(input, word, replace);
      if (replaced) {
        input = replaced;
      }
    } while (replaced);
    return input;
  },
  updateAndOrInstance: function(input, word, replace) {
    const wordIndex = input.indexOf(word);
    if (wordIndex === -1) {
      return null;
    }
    const leftIndex = this.findLeft(input, wordIndex);
    const rightIndex = this.findRight(input, wordIndex + word.length);
    if (leftIndex > -1 && rightIndex > -1) {
      input = input.slice(0, rightIndex) + ")" + input.slice(rightIndex);
      input = input.slice(0, leftIndex) + `${replace}(` + input.slice(leftIndex);
      input = input.replace(word, ",");
      return input;
    }
    return null;
  },
  /*
      start at the "and" and work left - increment for ), decrement for (, once you hit -1, that is your left paren -- add "and(" here
  */
  findLeft: function(input, index) {
    let count = 0;
    do {
      index--;
      if (input[index] === ")") {
        count++;
      }
      if (input[index] === "(") {
        count--;
      }
      if (count === -1) {
        return index + 1;
      }
    } while (index >= 0);
    return -1;
  },
  /*
      start at the "and" and work right - increment for (, decrement for ), once you hit -1, that is your right paren -- add ")" here
  */
  findRight: function(input, index) {
    let count = 0;
    do {
      index++;
      if (input[index] === "(") {
        count++;
      }
      if (input[index] === ")") {
        count--;
      }
      if (input[index] === "," && count === 0) {
        count--;
      }
      if (count === -1) {
        return index;
      }
    } while (index < input.length);
    return -1;
  }
};

// src/services/giving-tree/global-calcuator.ts
var instance;
function getInstance() {
  return instance;
}
var Calculator = class {
  treeNodeMap;
  valuePropJson;
  variables;
  valueDrivers;
  ourPriceComponents;
  competitorPriceComponents;
  totals;
  constructor(treeNodeMap, valuePropJson, valueDrivers, ourPriceComponents, competitorPriceComponents) {
    instance = this;
    this.treeNodeMap = treeNodeMap;
    this.valuePropJson = valuePropJson;
    this.valueDrivers = valueDrivers;
    this.ourPriceComponents = ourPriceComponents;
    this.competitorPriceComponents = competitorPriceComponents;
    this.totals = {
      caseRoi: { value: 0, precision: 0, variableType: "percent", type: "globals" },
      competitorPrice: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      compPricePlusDiffValue: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      differentiationValue: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      positiveDifferentiationValue: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      efficiencyDifferentiationValue: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      incrementalRoi: { value: 0, precision: 0, variableType: "percent", type: "globals" },
      ourPrice: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      totalValue: { value: 0, precision: 0, variableType: "currency", type: "globals" },
      valueToCustomer: { value: 0, precision: 0, variableType: "currency", type: "globals" }
    };
  }
  getTotals() {
    return this.totals;
  }
  calculateValueDriver(valueDriverNode) {
    const map = this.treeNodeMap;
    const valuePropJson = this.valuePropJson;
    const displayUnitOfMeasureId = this.getDisplayUnitId(valuePropJson.ConversionSettings);
    const valueDriver = valueDriverNode.valueDriver;
    const value = valueDriverNode.value;
    const rawValue = valueDriver.IsNegative && value > 0 ? -value : value;
    valueDriverNode.unitValue = this.getUnitableValue(rawValue, valueDriver.UnitOfMeasureGuid, displayUnitOfMeasureId, map, valuePropJson.ConversionSettings);
  }
  getValueDriverConversion(valueDriverNode) {
    const map = this.treeNodeMap;
    const valuePropJson = this.valuePropJson;
    const valueDriver = valueDriverNode.valueDriver;
    const uomUid = valuePropJson.ConversionSettings.OverrideSelectedUomUID ? valuePropJson.ConversionSettings.OverrideSelectedUomUID : valuePropJson.ConversionSettings.SelectedUomUID;
    const from = this.valuePropJson.ConversionSettings.UnitsOfMeasure[uomUid].Name;
    const to = this.valuePropJson.ConversionSettings.UnitsOfMeasure[valueDriver.UnitOfMeasureGuid].Name;
    const conversionFactor = this.getConversionFactorValue(uomUid, valueDriver.UnitOfMeasureGuid, map, valuePropJson.ConversionSettings);
    return {
      from,
      to,
      conversionFactor
    };
  }
  calculatePriceComponent(priceComponentNode) {
    const map = this.treeNodeMap;
    const valuePropJson = this.valuePropJson;
    const displayUnitOfMeasureId = this.getDisplayUnitId(valuePropJson.ConversionSettings);
    const priceComponent = priceComponentNode.priceComponent;
    const value = priceComponentNode.value;
    priceComponentNode.unitValue = this.getUnitableValue(value, priceComponent.UnitOfMeasureGuid, displayUnitOfMeasureId, map, valuePropJson.ConversionSettings);
  }
  calculateTotals() {
    const valuePropJson = this.valuePropJson;
    for (const valueDriver of this.valueDrivers) {
      this.calculateValueDriver(valueDriver);
    }
    for (const priceComponent of this.ourPriceComponents) {
      this.calculatePriceComponent(priceComponent);
    }
    for (const priceComponent of this.competitorPriceComponents) {
      this.calculatePriceComponent(priceComponent);
    }
    const competitorPrice = this.sumPriceComponents(this.competitorPriceComponents, valuePropJson.Overrides.NBCAPriceOverrides);
    const ourPrice = this.sumPriceComponents(this.ourPriceComponents, valuePropJson.Overrides.PriceOverrides);
    const differentiationValue = this.calculateDiffValue(this.valueDrivers, valuePropJson.Overrides.ValueDriverOverrides);
    const positiveDifferentiationValue = this.calculatePositiveDiffValue(this.valueDrivers, valuePropJson.Overrides.ValueDriverOverrides);
    const additionalInvestment = ourPrice - competitorPrice;
    const valueToCustomer = differentiationValue - additionalInvestment;
    const totalValue = competitorPrice + differentiationValue;
    const caseROI = ourPrice != 0 ? valueToCustomer / ourPrice : 0;
    const incrementalROI = additionalInvestment > 0 ? (differentiationValue - additionalInvestment) / additionalInvestment : 0;
    const efficiencyDifferentiationValue = this.getEfficiencyAdjustedDiffValue(differentiationValue, competitorPrice, this.treeNodeMap, valuePropJson.ConversionSettings);
    this.totals.ourPrice.value = ourPrice;
    this.totals.competitorPrice.value = competitorPrice;
    this.totals.differentiationValue.value = differentiationValue;
    this.totals.positiveDifferentiationValue.value = positiveDifferentiationValue;
    this.totals.valueToCustomer.value = valueToCustomer;
    this.totals.totalValue.value = totalValue;
    this.totals.caseRoi.value = caseROI;
    this.totals.incrementalRoi.value = incrementalROI;
    this.totals.efficiencyDifferentiationValue.value = efficiencyDifferentiationValue;
  }
  sumPriceComponents(priceComponentNodes, priceComponentOverrides) {
    let total = 0;
    for (const priceComponentNode of priceComponentNodes) {
      const priceComponent = priceComponentNode.priceComponent;
      if (this.isPriceComponentIncluded(priceComponent, priceComponentOverrides))
        total += priceComponentNode.unitValue;
    }
    return total;
  }
  calculateDiffValue(driverNodes, valueDriverOverrides) {
    let diffValue = 0;
    for (const driverNode of driverNodes) {
      const valueDriver = driverNode.valueDriver;
      if (this.isValueDriverIncluded(valueDriver, valueDriverOverrides)) {
        diffValue += driverNode.unitValue;
      }
    }
    return diffValue;
  }
  calculatePositiveDiffValue(driverNodes, valueDriverOverrides) {
    let diffValue = 0;
    for (const driverNode of driverNodes) {
      const valueDriver = driverNode.valueDriver;
      if (!valueDriver.isNegative && this.isValueDriverIncluded(valueDriver, valueDriverOverrides)) {
        diffValue += driverNode.unitValue;
      }
    }
    return diffValue;
  }
  EFFICIENCY_FACTOR_DEFAULT;
  EFFICIENCY_PRICE_MODE;
  BASIC_MODEL;
  MYA_MODEL;
  resolveOverridableValue(optionalOverride, baseValue) {
    return optionalOverride == null ? baseValue : optionalOverride;
  }
  getDisplayUnitId(conversionSettings) {
    return this.resolveOverridableValue(
      conversionSettings.OverrideSelectedUomUID,
      conversionSettings.SelectedUomUID
    );
  }
  getEfficiencyAdjustedDiffValue(diffValue, competitorPrice, variables, conversionSettings) {
    const adjustmentFactor = this.getAcquisitionEfficiencyFactorValue(variables, conversionSettings);
    const adjustment = competitorPrice * (1 - 1 / adjustmentFactor);
    return diffValue + adjustment;
  }
  getAcquisitionEfficiencyFactorValue(variables, conversionSettings) {
    const ModelType = this.valuePropJson.ModelType === this.MYA_MODEL ? this.MYA_MODEL : this.BASIC_MODEL;
    if (this.BASIC_MODEL != ModelType) {
      return this.EFFICIENCY_FACTOR_DEFAULT;
    }
    const EfficiencyMode = this.valuePropJson.ConversionSettings.EfficiencyPriceMode;
    if (this.EFFICIENCY_PRICE_MODE != EfficiencyMode) {
      return this.EFFICIENCY_FACTOR_DEFAULT;
    }
    const competitorUofMId = conversionSettings.CompetitorUomUID;
    const offeringUofMId = conversionSettings.OfferingUomUID;
    const competitorToOfferingConversionFactorValue = this.getConversionFactorValue(competitorUofMId, offeringUofMId, variables, conversionSettings);
    const efficiencyFactorVariableId = conversionSettings.EfficiencyFactorUID;
    const acquisitionEfficiencyRatio = variables[efficiencyFactorVariableId].value;
    const result = competitorToOfferingConversionFactorValue * acquisitionEfficiencyRatio;
    return result <= 0 ? this.EFFICIENCY_FACTOR_DEFAULT : result;
  }
  getUnitableValue(rawValue, fromUnitId, toUnitId, variables, conversionSettings) {
    return rawValue * this.getConversionFactorValue(fromUnitId, toUnitId, variables, conversionSettings);
  }
  getConversionFactorValue(fromUnitId, toUnitId, variables, conversionSettings) {
    let fromToBaseConversionFactor = 1;
    let baseToToConversionFactor = 1;
    const conversionFactors = conversionSettings.ConversionFactors;
    const fromUnit = conversionSettings.UnitsOfMeasure[fromUnitId];
    const toUnit = conversionSettings.UnitsOfMeasure[toUnitId];
    for (const uid in conversionFactors) {
      const conversionFactor = conversionFactors[uid];
      if (fromUnit?.UnitOfMeasureUID === conversionFactor.ToUnitUID) {
        const factorVariableNode = variables[conversionFactor.VariableUID];
        fromToBaseConversionFactor = 1 / factorVariableNode.value;
      }
      if (toUnit?.UnitOfMeasureUID === conversionFactor.ToUnitUID) {
        const factorVariableNode = variables[conversionFactor.VariableUID];
        baseToToConversionFactor = factorVariableNode.value;
      }
    }
    return fromToBaseConversionFactor * baseToToConversionFactor;
  }
  isPriceComponentIncluded(priceComponent, overrides) {
    const priceComponentKey = priceComponent.PriceComponentId.toString();
    const optionalOverride = overrides[priceComponentKey];
    return this.resolveOverridableValue(optionalOverride?.Included, priceComponent.Included);
  }
  isValueDriverIncluded(valueDriver, overrides) {
    const valueDriverKey = valueDriver.Id.toString();
    const optionalOverride = overrides[valueDriverKey];
    return this.resolveOverridableValue(optionalOverride?.Enabled, valueDriver.Enabled);
  }
};

// src/types/giving-tree/value-driver-proxy.ts
var ValueDriverProxy = class {
  node;
  constructor(node) {
    this.node = node;
  }
  get id() {
    return this.node.valueDriver.Id;
  }
  get uid() {
    return this.node.valueDriver.VariableUID;
  }
  get hookId() {
    return this.node.valueDriver.HookId;
  }
  get name() {
    return this.node.valueDriver.Name;
  }
  // todo which one?
  get label() {
    return this.node.valueDriver.DisplayLabel;
  }
  get display() {
    return this.node.valueDriver.DisplayLabel;
  }
  get message() {
    return this.node.valueDriver.ValueMessage;
  }
  get questions() {
    return this.node.valueDriver.PainPoints;
  }
  // todo value is gonna have to be calculated with those units etc
  get value() {
    if (this.override) {
      return this.node.variable.ValuePropValue.OverrideValue;
    }
    if (this.node.unitValue) {
      return this.node.unitValue;
    }
    return 0;
  }
  get formulaSummary() {
    const calc = getInstance();
    const conversion = calc.getValueDriverConversion(this.node);
    return {
      conversion,
      formula: new VariableProxy(this.node).formulaSummary
    };
  }
  set value(value) {
    if (this.override) {
      this.node.variable.ValuePropValue.OverrideValue = value;
    }
  }
  get override() {
    return this.node.variable.ValuePropValue.OverrideUsesFormula === false;
  }
  set override(value) {
    this.node.variable.ValuePropValue.OverrideUsesFormula = !value;
  }
  get negative() {
    return this.node.valueDriver.IsNegative;
  }
  get notes() {
    return this.node.variable.ValuePropValue.Notes;
  }
  get precision() {
    return this.node.variable.ValuePropValue.Precision;
  }
  get tags() {
    return this.node.variable.ValuePropValue.Tags;
  }
  get formula() {
    return this.node.variable.Definition;
  }
  // todo
  get definedUnitName() {
    return "";
  }
  get enabled() {
    return this.node.valueDriver.Enabled;
  }
  get textValue() {
    return "";
  }
  get variableType() {
    return "currency";
  }
  get type() {
    return "value-driver";
  }
};

// src/types/giving-tree/price-component-proxy.ts
var PriceComponentProxy = class {
  node;
  constructor(node) {
    this.node = node;
  }
  get competitor() {
    return this.node.priceComponent.competitor;
  }
  get uid() {
    return this.node.priceComponent.VariableUID;
  }
  get hookId() {
    return this.node.priceComponent.HookId;
  }
  get name() {
    return this.node.variable.Name;
  }
  get description() {
    return this.node.priceComponent.Message;
  }
  get value() {
    if (this.override) {
      return this.node.variable.ValuePropValue.OverrideValue;
    }
    if (this.node.unitValue) {
      return this.node.unitValue;
    }
    return 0;
  }
  get formulaSummary() {
    return new VariableProxy(this.node).formulaSummary;
  }
  set value(value) {
    if (this.override) {
      this.node.variable.ValuePropValue.OverrideValue = value;
    }
  }
  get override() {
    return this.node.variable.ValuePropValue.OverrideUsesFormula === false;
  }
  set override(value) {
    this.node.variable.ValuePropValue.OverrideUsesFormula = !value;
  }
  get precision() {
    return this.node.variable.ValuePropValue.Precision;
  }
  get tags() {
    return this.node.variable.ValuePropValue.Tags;
  }
  get formula() {
    return this.node.variable.Definition;
  }
  // todo
  get definedUnitName() {
    return "";
  }
  get enabled() {
    return this.node.priceComponent.Included;
  }
  get textValue() {
    return "";
  }
  get variableType() {
    return "currency";
  }
  get type() {
    return "price-component";
  }
};

// src/types/giving-tree/variable-proxy.ts
var VariableProxy = class _VariableProxy {
  node;
  static defaultCurrencyPrecision;
  static defaultPercentPrecision;
  static defaultCountPrecision;
  constructor(node) {
    this.node = node;
  }
  get uid() {
    return this.node.variable.VariableUID;
  }
  get name() {
    return this.node.variable.Name;
  }
  get tags() {
    return this.node.variable.ValuePropValue.Tags;
  }
  get notes() {
    if (!this.node.variable.ValuePropValue.OverrideNotes) {
      return this.node.variable.ValuePropValue.Notes;
    }
    return this.node.variable.ValuePropValue.OverrideNotes;
  }
  get overrideNotes() {
    return this.node.variable.ValuePropValue.OverrideNotes;
  }
  set notes(notes) {
    this.node.variable.ValuePropValue.OverrideNotes = notes;
    if (window["gwtVariables"] && window["gwtVariables"].get(this.uid)) {
      const data = window["gwtVariables"].get(this.uid).data_0;
      data["ValuePropValue"]["OverrideNotes"] = notes;
    }
  }
  get associatedRoots() {
    const valueDrivers = [];
    const priceComponents = [];
    const importantVariables = [];
    findRoots(this.node, valueDrivers, priceComponents, importantVariables);
    return {
      valueDrivers,
      priceComponents,
      importantVariables
    };
  }
  get formulaSummary() {
    if (!this.hasFormula) {
      return null;
    }
    let definition = "result = " + this.formula;
    const variables = [];
    variables.push({
      letter: "result",
      name: this.node.name,
      value: this.node.value,
      hookId: this.node.variable.HookId
    });
    for (const childIndex in this.node.children) {
      const letter = FormulaUtility.numberToLetter(childIndex);
      definition = FormulaUtility.convertParameterNumberToLetter(definition, childIndex, letter);
      variables.push({
        letter,
        name: this.node.children[childIndex].name,
        value: this.node.children[childIndex].value,
        hookId: this.node.children[childIndex].variable.HookId
      });
    }
    return {
      value: this.node.value,
      formula: definition,
      variables
    };
  }
  get source() {
    if (!this.node.variable.ValuePropValue.OverrideSource) {
      return this.node.variable.ValuePropValue.Source;
    }
    return this.node.variable.ValuePropValue.OverrideSource;
  }
  set source(source) {
    this.node.variable.ValuePropValue.OverrideSource = source;
  }
  get variableType() {
    switch (this.node.variable.DataType) {
      case 1:
        return "currency";
      case 2:
        return "percent";
      case 3:
        return "count";
    }
    return "";
  }
  get type() {
    return "variable";
  }
  get metaType() {
    switch (this.node.variable.Type) {
      case 1:
        return "basic";
      case 2:
        return "conversion factor";
      case 3:
        return "vd root";
      case 4:
        return "nbca root";
    }
    return "";
  }
  get vpHasFormula() {
    return this.node.variable.ValuePropValue.UsesFormula;
  }
  get hasFormula() {
    if (this.node.variable.ValuePropValue.OverrideUsesFormula !== null) {
      return this.node.variable.ValuePropValue.OverrideUsesFormula;
    }
    return this.node.variable.ValuePropValue.UsesFormula;
  }
  get formula() {
    return this.node.variable.Definition;
  }
  get hookId() {
    return this.node.variable.HookId;
  }
  get display() {
    return "";
  }
  isLockedRange() {
    return this.node.variable.ValuePropValue.LockedState === 2;
  }
  get hasRange() {
    return this.isLockedRange();
  }
  get min() {
    return this.isLockedRange() ? this.node.variable.ValuePropValue.MinimumValue : null;
  }
  get max() {
    return this.isLockedRange() ? this.node.variable.ValuePropValue.MaximumValue : null;
  }
  get precision() {
    if (this.node.variable.ValuePropValue.OverridePrecision !== null) {
      return this.node.variable.ValuePropValue.OverridePrecision;
    }
    if (this.node.variable.ValuePropValue.Precision !== null) {
      return this.node.variable.ValuePropValue.Precision;
    }
    switch (this.variableType) {
      case "currency":
        return _VariableProxy.defaultCurrencyPrecision;
      case "percent":
        return _VariableProxy.defaultPercentPrecision;
      case "count":
        return _VariableProxy.defaultCountPrecision;
    }
    return 0;
  }
  get isChoice() {
    return this.node.variable.LogicType === 1;
  }
  get selectedChoiceName() {
    if (this.node.variable.LogicType === 1) {
      const choiceVariable = this.node.variable;
      const selectedChoiceId = choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId == null ? choiceVariable.ValuePropLogicDefinition.SelectedChoiceId : choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId;
      for (const choice of choiceVariable.ValuePropLogicDefinition.Choices) {
        if (choice.UniqueId === selectedChoiceId) {
          return choice.Name;
        }
      }
    }
    return "";
  }
  get readOnly() {
    return this.node.variable.ValuePropValue.LockedState === 1;
  }
  get rawValue() {
    return this.node.value;
  }
  get choices() {
    const choices = [];
    if (this.node.variable.LogicType === 1) {
      const choiceVariable = this.node.variable;
      for (const choice of choiceVariable.ValuePropLogicDefinition.Choices) {
        choices.push({ name: choice.Name, value: choice.Value, id: choice.UniqueId });
      }
    }
    return choices;
  }
  get overrideSelectedChoiceId() {
    if (this.node.variable.LogicType === 1) {
      return this.node.variable.ValuePropLogicDefinition.OverrideSelectedChoiceId;
    }
    return "";
  }
  get selectedChoiceId() {
    if (this.node.variable.LogicType === 1) {
      const choiceVariable = this.node.variable;
      return choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId == null ? choiceVariable.ValuePropLogicDefinition.SelectedChoiceId : choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId;
    }
    return "";
  }
  set selectedChoiceIdNoUpdate(id) {
    if (this.node.variable.LogicType === 1) {
      const choiceVariable = this.node.variable;
      if (choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId === id) {
        return;
      }
      choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId = id;
      for (const choice of this.choices) {
        if (choice.id === id) {
          this.node.value = choice.value;
        }
      }
    }
  }
  set selectedChoiceId(id) {
    if (this.node.variable.LogicType === 1) {
      const previous = this.value;
      const choiceVariable = this.node.variable;
      if (choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId === id) {
        return;
      }
      choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId = id;
      for (const choice of this.choices) {
        if (choice.id === id) {
          this.node.value = choice.value;
        }
      }
      thingsHaveChanged(this.node);
      if (window["ValuePropositionAPI"]) {
        window["ValuePropositionAPI"].refresh();
      }
      emitValueModelUpdateEvent(this.hookId, previous, this.value);
    }
  }
  isPercent = () => {
    return this.node.variable.DataType == 2;
  };
  roundNumber = (value, precision) => {
    const factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
  };
  set overrideValue(value) {
  }
  get value() {
    if (this.node.value) {
      if (this.isPercent()) {
        return this.node.value * 100;
      }
      return this.node.value;
    }
    return 0;
  }
  get overrideValue() {
    if (!this.hasFormula) {
      return this.node.variable.ValuePropValue.OverrideValue;
    }
    return null;
  }
  get displayValue() {
    if (this.node.value) {
      if (this.isPercent()) {
        return this.roundNumber(this.node.value * 100, this.precision);
      }
      return this.roundNumber(this.node.value, this.precision);
    }
    return 0;
  }
  get textValue() {
    return "";
  }
  set value(value) {
    const isNumber = typeof value === "number";
    const previous = this.value;
    if (value === previous) {
      this.node.variable.ValuePropValue.OverrideValue = value;
      this.updateGWTVariable();
      return;
    }
    if (value === null) {
      if (this.node.variable.ValuePropValue.OverrideValue) {
        return;
      }
      const isSame = this.node.variable.ValuePropValue.OverrideValue === this.node.variable.ValuePropValue.SavedValue;
      this.node.variable.ValuePropValue.OverrideUsesFormula = null;
      this.node.variable.ValuePropValue.OverrideValue = null;
      const gwtUpdated2 = this.updateGWTVariable();
      if (!isSame) {
        emitValueModelUpdateEvent(this.hookId, previous, null);
        thingsHaveChanged(this.node);
        if (gwtUpdated2) {
          if (window["ValuePropositionAPI"]) {
            window["ValuePropositionAPI"].refresh();
          }
        }
      }
      return;
    }
    if (this.isChoice) {
      let foundValue = false;
      for (const choice of this.choices) {
        if (choice.value === (isNumber ? value : value.value)) {
          this.selectedChoiceIdNoUpdate = choice.id;
          this.node.value = choice.value;
          foundValue = true;
        }
      }
      if (!foundValue) {
        throw `Could not find value ${value} on choices ${this.hookId}`;
      }
      if (isNumber || value.updateTree) {
        if (window["ValuePropositionAPI"]) {
          window["ValuePropositionAPI"].refresh();
        }
      }
    } else if (this.isPercent()) {
      this.node.value = isNumber ? value / 100 : value.value;
    } else {
      this.node.value = isNumber ? value : value.value;
    }
    if (this.hasFormula) {
      this.node.variable.ValuePropValue.OverrideUsesFormula = false;
    }
    const gwtUpdated = this.updateGWTVariable();
    this.node.variable.ValuePropValue.OverrideValue = this.node.value;
    if (isNumber || value.updateTree) {
      emitValueModelUpdateEvent(this.hookId, previous, this.node.value);
      thingsHaveChanged(this.node);
      if (gwtUpdated) {
        if (window["ValuePropositionAPI"]) {
          window["ValuePropositionAPI"].refresh();
        }
      }
    } else if (!isNumber && value.time) {
      this.node.time = value.time;
      updateTree(this.node, value.time, []);
    }
  }
  updateGWTVariable = () => {
    if (window["gwtVariables"] && window["gwtVariables"].get(this.uid)) {
      const data = window["gwtVariables"].get(this.uid).data_0;
      console.log("updating", data, this.hookId);
      if (this.isChoice) {
        if (data["ValuePropLogicDefinition"]["OverrideSelectedChoiceId"] === this.selectedChoiceId) {
          return false;
        }
        data["ValuePropLogicDefinition"]["OverrideSelectedChoiceId"] = this.selectedChoiceId;
        console.log("choice", data);
      } else {
        const converted = this.isPercent() ? this.value / 100 : this.value;
        if (data["ValuePropValue"]["OverrideValue"] === converted) {
          return false;
        }
        data["ValuePropValue"]["OverrideValue"] = converted;
      }
    }
    return true;
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set sync(value) {
  }
};
function findRoots(node, valueDrivers, priceComponents, variables) {
  if (node.parents.length === 0) {
    if (node.valueDriver && node.valueDriver.Enabled && valueDrivers.indexOf(node.valueDriver.Name) === -1) {
      valueDrivers.push(node.valueDriver.Name);
    }
    if (node.priceComponent && node.priceComponent.Enabled && priceComponents.indexOf(node.priceComponent.Name) === -1) {
      priceComponents.push(node.valueDriver.Name);
    }
    if (!node.valueDriver && !node.priceComponent && variables.indexOf(node.variable.Name) === -1) {
      variables.push(node.variable.Name);
    }
  }
  for (const parent of node.parents) {
    findRoots(parent, valueDrivers, priceComponents, variables);
  }
}
function emitValueModelUpdateEvent(hookId, previous, updated) {
  if (previous === updated) {
    return;
  }
  const languageCode = "";
  const vmId = 0;
  const uvpId = 0;
  const vpId = 0;
  const source = null;
  const event = new CustomEvent(
    "modelUpdatedEvent",
    {
      "detail": {
        "type": "variable",
        "languageCode": languageCode,
        "vmId": vmId,
        "vpId": vpId,
        "uvpId": uvpId,
        "hookId": hookId,
        "previous": previous,
        "updated": updated,
        "previousNotes": null,
        "updatedNotes": null,
        "source": source
      }
    }
  );
  document.dispatchEvent(event);
}
function thingsHaveChanged(node) {
  const time = (/* @__PURE__ */ new Date()).getTime();
  const roots = [];
  updateTree(node, time, roots);
  const updatedVariables = calcTree(roots, time);
  const calc = getInstance();
  calc.calculateTotals();
  const variables = [];
  for (const node2 of updatedVariables) {
    const variable = new VariableProxy(node2);
    if (variable.hookId) {
      variables.push(variable);
    }
  }
  getInstance2().sync(
    variables,
    calc.valueDrivers.map((node2) => new ValueDriverProxy(node2)),
    [...calc.ourPriceComponents.map((node2) => new PriceComponentProxy(node2)), ...calc.competitorPriceComponents.map((node2) => new PriceComponentProxy(node2))],
    calc.totals
  );
}

// src/types/giving-tree/meta-proxy.ts
var MetaProxy = class {
  json;
  hookId;
  constructor(json, hookId) {
    this.json = json;
    this.hookId = hookId;
  }
  getValue(field) {
    const override = this.json.Overrides[field];
    return override !== null && override != "" ? override : this.json[field];
  }
  get isChoice() {
    return this.hookId === "meta-customer-unit";
  }
  get selectedChoiceName() {
    if (this.hookId === "meta-customer-unit") {
      const uomUid = this.json.ConversionSettings.OverrideSelectedUomUID ? this.json.ConversionSettings.OverrideSelectedUomUID : this.json.ConversionSettings.SelectedUomUID;
      return this.json.ConversionSettings.UnitsOfMeasure[uomUid].Name;
    }
    return "";
  }
  get selectedChoiceId() {
    if (this.hookId === "meta-customer-unit") {
      return this.json.ConversionSettings.OverrideSelectedUomUID ? this.json.ConversionSettings.OverrideSelectedUomUID : this.json.ConversionSettings.SelectedUomUID;
    }
    return "";
  }
  set selectedChoiceId(id) {
    if (this.hookId === "meta-customer-unit") {
      this.json.ConversionSettings.OverrideSelectedUomUID = id;
      const calc = getInstance();
      calc.calculateTotals();
      const variables = [];
      const nodes = Object.values(calc.treeNodeMap);
      for (const node of nodes) {
        const variable = new VariableProxy(node);
        if (variable.hookId) {
          variables.push(variable);
        }
      }
      getInstance2().sync(
        variables,
        calc.valueDrivers.map((node) => new ValueDriverProxy(node)),
        [...calc.ourPriceComponents.map((node) => new PriceComponentProxy(node)), ...calc.competitorPriceComponents.map((node) => new PriceComponentProxy(node))],
        calc.totals
      );
    }
  }
  getConversionFactor = (uuid1, uuid2) => {
    const data = this.json.ConversionSettings.ConversionFactors;
    for (const key in data) {
      if (data[key].FromUnitUID === uuid1 && data[key].ToUnitUID === uuid2 || data[key].FromUnitUID === uuid2 && data[key].ToUnitUID === uuid1) {
        return this.json.Data[data[key].VariableUID].ValuePropValue.SavedValue;
      }
    }
  };
  get choices() {
    const choices = [];
    if (this.hookId === "meta-customer-unit") {
      const customer = this.json.ConversionSettings.UnitsOfMeasure[this.json.ConversionSettings.DefaultUomUID];
      const competitor = this.json.ConversionSettings.UnitsOfMeasure[this.json.ConversionSettings.CompetitorUomUID];
      const offering = this.json.ConversionSettings.UnitsOfMeasure[this.json.ConversionSettings.OfferingUomUID];
      choices.push({ name: customer.Name, value: customer.UnitOfMeasureUID, id: customer.UnitOfMeasureUID });
      if (offering.Name !== customer.Name || competitor.Name !== customer.Name || this.getConversionFactor(customer.UnitOfMeasureUID, offering.UnitOfMeasureUID) !== 1 || this.getConversionFactor(customer.UnitOfMeasureUID, competitor.UnitOfMeasureUID) !== 1) {
        if (competitor.Name && this.json.NBCA.Name) {
          choices.push({ name: `${competitor.Name} of ${this.json.NBCA.Name}`, value: competitor.UnitOfMeasureUID, id: competitor.UnitOfMeasureUID });
        }
        if (offering.Name && this.json.Offering) {
          choices.push({
            name: `${offering.Name} of ${this.json.Offering}`,
            value: offering.UnitOfMeasureUID,
            id: offering.UnitOfMeasureUID
          });
        }
      }
      for (const uofm of Object.values(this.json.ConversionSettings.UnitsOfMeasure).filter((uofm2) => uofm2 != competitor && uofm2 != offering && uofm2 != customer)) {
        if (uofm.ShowInVP && choices.findIndex((choice) => choice.name === uofm.Name) === -1) {
          if (uofm.Name) {
            choices.push({ name: uofm.Name, value: uofm.UnitOfMeasureUID, id: uofm.UnitOfMeasureUID });
          }
        }
      }
    }
    return choices;
  }
  getField() {
    switch (this.hookId) {
      case "meta-currency":
        return "CurrencyCode";
      case "meta-locale":
        return "DisplayLocale";
      case "meta-name":
        return "Name";
      case "meta-description":
        return "Description";
      case "meta-customer":
        return "Company";
      case "meta-competitor":
        return "Competitor";
      case "meta-competitor-notes":
        return "CompetitorNotes";
      case "meta-offering":
        return "Offering";
      case "meta-customer-unit":
        return "Customer Unit";
    }
    return "";
  }
  get textValue() {
    if (this.hookId === "meta-customer-unit") {
      const uomUid = this.json.ConversionSettings.OverrideSelectedUomUID ? this.json.ConversionSettings.OverrideSelectedUomUID : this.json.ConversionSettings.SelectedUomUID;
      return this.json.ConversionSettings.UnitsOfMeasure[uomUid].Name;
    }
    return this.getValue(this.getField());
  }
  get overrideValue() {
    return this.json.Overrides[this.getField()];
  }
  get text() {
    return this.textValue;
  }
  get value() {
    return 0;
  }
  get precision() {
    return 0;
  }
  get name() {
    switch (this.hookId) {
      case "meta-name":
        return "Name";
      case "meta-description":
        return "Description";
      case "meta-customer":
        return "Customer";
      case "meta-offering":
        return "Offering";
      case "meta-competitor":
        return "Competitor";
      case "meta-competitor-notes":
        return "Competitor Notes";
      case "meta-customer-unit":
        return "Customer Unit";
      case "meta-currency":
        return "Currency";
      case "meta-locale":
        return "Locale";
    }
    return "";
  }
  set textValue(input) {
    if (this.hookId === "meta-customer-unit") {
      return;
    }
    this.json.Overrides[this.getField()] = input;
  }
  get readOnly() {
    if (this.hookId === "meta-customer-unit") {
      return true;
    }
    return false;
  }
  get variableType() {
    return "";
  }
  get type() {
    return "meta";
  }
};

// src/types/giving-tree/feature-proxy.ts
var FeatureProxy = class {
  json;
  id;
  constructor(json, id) {
    this.json = json;
  }
  get name() {
    return this.json.Name;
  }
  get type() {
    return "feature";
  }
  get notes() {
    return this.json.Notes;
  }
  get order() {
    return this.json.Order;
  }
  benefitIds;
  hookId;
  precision;
  textValue;
  value;
  variableType;
};

// src/types/giving-tree/benefit-proxy.ts
var BenefitProxy = class {
  json;
  id;
  /* sample json
  {
    "BenefitId": 177239,
    "Name": "High throughput",
    "BenefitGuid": "692460f9-e419-4e42-9d6f-70d3129d85d6",
    "LinkedFeatureGuids": [
      "35afffcd-9a77-4f50-8e6f-0165b3a6e148"
    ],
    "IsNegative": false,
    "Order": 0,
    "Notes": null
  },
   */
  constructor(json, id) {
    this.json = json;
  }
  get name() {
    return this.json.Name;
  }
  get notes() {
    return this.json.Notes;
  }
  get order() {
    return this.json.Order;
  }
  get type() {
    return "benefit";
  }
  valueDriverHookIds;
  hookId;
  precision;
  textValue;
  value;
  variableType;
};

// src/services/giving-tree/tree-pinia-adapter.ts
var instance2;
function getInstance2() {
  return instance2;
}
var PiniaInitializer = class {
  valueModelStore;
  constructor(valueModelStore) {
    instance2 = this;
    this.valueModelStore = valueModelStore;
  }
  initPinia(map, roots, valuePropJson, globalCalculations) {
    const valueDriversByHookId = {};
    const variablesByHookId = {};
    const priceComponentsByHookId = {};
    const metaByHookId = {};
    const nodes = Object.values(map);
    for (const node of nodes) {
      const variable = new VariableProxy(node);
      variablesByHookId[variable.hookId] = variable;
      if (node.valueDriver) {
        const valueDriver = new ValueDriverProxy(node);
        valueDriversByHookId[valueDriver.hookId] = valueDriver;
      }
      if (node.priceComponent) {
        const priceComponent = new PriceComponentProxy(node);
        priceComponentsByHookId[priceComponent.hookId] = priceComponent;
      }
    }
    metaByHookId["meta-name"] = new MetaProxy(valuePropJson, "meta-name");
    metaByHookId["meta-description"] = new MetaProxy(valuePropJson, "meta-description");
    metaByHookId["meta-customer"] = new MetaProxy(valuePropJson, "meta-customer");
    metaByHookId["meta-offering"] = new MetaProxy(valuePropJson, "meta-offering");
    metaByHookId["meta-competitor"] = new MetaProxy(valuePropJson, "meta-competitor");
    metaByHookId["meta-competitor-notes"] = new MetaProxy(valuePropJson, "meta-competitor-notes");
    metaByHookId["meta-competitor"] = new MetaProxy(valuePropJson, "meta-competitor");
    metaByHookId["meta-customer-unit"] = new MetaProxy(valuePropJson, "meta-customer-unit");
    metaByHookId["meta-locale"] = new MetaProxy(valuePropJson, "meta-locale");
    metaByHookId["meta-currency"] = new MetaProxy(valuePropJson, "meta-currency");
    const featuresById = {};
    const benefitsById = {};
    for (const feature of valuePropJson.PositiveFeatures) {
      featuresById[feature.FeatureGuid] = new FeatureProxy(feature, feature.FeatureGuid);
    }
    for (const benefit of valuePropJson.PositiveBenefits) {
      benefitsById[benefit.BenefitGuid] = new BenefitProxy(benefit, benefit.BenefitGuid);
    }
    const state = {
      roots,
      globalCalculations,
      metaByHookId,
      valueDriversByHookId,
      variablesByHookId,
      priceComponentsByHookId,
      features: featuresById,
      benefits: benefitsById,
      recalculate: (time, otherUpdatedVariables) => {
        const updatedVariables = calcTree(roots, time);
        const calc = getInstance();
        calc.calculateTotals();
        const variables = [];
        for (const node of updatedVariables) {
          const variable = new VariableProxy(node);
          if (variable.hookId) {
            variables.push(variable);
          }
        }
        getInstance2().sync(
          [...variables, ...otherUpdatedVariables],
          calc.valueDrivers.map((node) => new ValueDriverProxy(node)),
          [...calc.ourPriceComponents.map((node) => new PriceComponentProxy(node)), ...calc.competitorPriceComponents.map((node) => new PriceComponentProxy(node))],
          calc.totals
        );
        this.emitValueModelUpdateEvent();
      }
    };
    if (this.valueModelStore) {
      this.valueModelStore.$state = state;
    }
    return state;
  }
  emitValueModelUpdateEvent() {
    const event = new CustomEvent(
      "modelUpdatedEvent",
      {
        "detail": {
          "type": "variable",
          "languageCode": "",
          "vmId": 0,
          "vpId": 0,
          "uvpId": 0,
          "hookId": "",
          "previous": 0,
          "updated": 0,
          "previousNotes": null,
          "updatedNotes": null,
          "source": null
        }
      }
    );
    document.dispatchEvent(event);
  }
  nodeUpdated(node) {
    if (node.variable.HookId && this.valueModelStore) {
      const value = {
        value: node.value,
        updateTree: false
      };
      this.valueModelStore.syncVariable(node.variable.HookId, value);
    }
  }
  sync(variables, valueDrivers, priceComponents, globalCalculations) {
    if (this.valueModelStore) {
      this.valueModelStore.sync(variables, valueDrivers, priceComponents, globalCalculations);
    }
  }
};

// src/services/giving-tree/calculator.ts
function calculateNode(node) {
  const variable = node.variable;
  let value;
  if (variable.LogicType === 1) {
    value = getSelectedChoiceValue(variable);
  } else if (usesCustomValue(variable)) {
    value = getCustomValue(variable);
  } else {
    value = calculateFormula(node);
  }
  node.value = value;
  if (node.valueDriver) {
    getInstance().calculateValueDriver(node);
  }
  if (node.priceComponent) {
    getInstance().calculatePriceComponent(node);
  }
}
function calculateNodeWithGlobal(node, globalCalculator) {
  const variable = node.variable;
  let value;
  if (variable.LogicType === 1) {
    value = getSelectedChoiceValue(variable);
  } else if (usesCustomValue(variable)) {
    value = getCustomValue(variable);
  } else {
    value = calculateFormula(node);
  }
  node.value = value;
  if (node.valueDriver) {
    globalCalculator.calculateValueDriver(node);
  }
  if (node.priceComponent) {
    globalCalculator.calculatePriceComponent(node);
  }
}
function getCustomValue(variable) {
  if (variable.ValuePropValue.OverrideValue == null) {
    return variable.ValuePropValue.SavedValue;
  }
  return variable.ValuePropValue.OverrideValue;
}
function usesCustomValue(variable) {
  if (variable.ValuePropValue.OverrideUsesFormula == null) {
    return !variable.ValuePropValue.UsesFormula;
  }
  return !variable.ValuePropValue.OverrideUsesFormula;
}
function getSelectedChoiceValue(choiceVariable) {
  const selectedChoiceId = choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId == null ? choiceVariable.ValuePropLogicDefinition.SelectedChoiceId : choiceVariable.ValuePropLogicDefinition.OverrideSelectedChoiceId;
  for (const choice of choiceVariable.ValuePropLogicDefinition.Choices) {
    if (choice.UniqueId === selectedChoiceId) {
      return choice.Value;
    }
  }
  return 0;
}
function calculateFormula(node) {
  let calculatedValue;
  const params = {};
  let definition = node.variable.Definition;
  definition = FormulaUtility.removeLinebreaks(definition);
  definition = FormulaUtility.convertNonLeadingZeroDecimals(definition);
  for (const childIndex in node.children) {
    const letter = FormulaUtility.numberToLetter(childIndex);
    definition = FormulaUtility.convertParameterNumberToLetter(definition, childIndex, letter);
    params[letter] = node.children[childIndex].value;
  }
  if (definition.trim().length === 0) {
    return 0;
  }
  if (definition.indexOf(" and ") > -1 || definition.indexOf(" or ") > -1) {
    definition = AndOrFormulaUtility.update(definition);
  }
  calculatedValue = (0, import_formula_pro.default)(definition, params);
  if (isNaN(calculatedValue)) {
    console.error(node.variable.HookId, definition, params);
  }
  if (isNaN(calculatedValue)) {
    calculatedValue = 0;
  }
  console.log(node.variable.HookId);
  return calculatedValue;
}
function updateTree(node, time, roots) {
  node.time = time;
  for (const parent of node.parents) {
    updateTree(parent, time, roots);
  }
  if (node.parents.length === 0) {
    roots.push(node);
  }
}
function recursiveAdd(node, time, queue) {
  if (time == null || node.time === time) {
    node.time = null;
    for (const child of node.children) {
      recursiveAdd(child, time, queue);
    }
    queue.push(node);
  }
}
function calcTree(roots, time) {
  const calculateQueue = [];
  for (const root of roots) {
    recursiveAdd(root, time, calculateQueue);
  }
  for (const node of calculateQueue) {
    calculateNode(node);
    getInstance2().nodeUpdated(node);
  }
  return calculateQueue;
}

// src/services/giving-tree/giving-tree.ts
var initTree = (valuePropJson) => {
  const treeMap = buildTree(valuePropJson);
  const treeRoots = getNodesWithoutParents(treeMap);
  return { map: treeMap, roots: treeRoots };
};
var initCalculations = (treeRoots, globalCalculator) => {
  const calculateQueue = [];
  for (const root of treeRoots) {
    recursiveAdd2(root, calculateQueue);
  }
  for (const node of calculateQueue) {
    calculateNodeWithGlobal(node, globalCalculator);
  }
};
function buildTree(valuePropJson) {
  const map = {};
  const valuePropData = valuePropJson.Data;
  const valueDrivers = {};
  const ourPriceComponents = {};
  const competitorPriceComponents = {};
  const conversionVariableUids = [];
  for (const valueDriver of valuePropJson.ValueDrivers) {
    valueDrivers[valueDriver.VariableUID] = valueDriver;
  }
  for (const priceComponent of valuePropJson.NBCA.PriceComponents) {
    competitorPriceComponents[priceComponent.VariableUID] = priceComponent;
  }
  for (const priceComponent of valuePropJson.Price.PriceComponents) {
    ourPriceComponents[priceComponent.VariableUID] = priceComponent;
  }
  for (const conversionFactor of Object.values(valuePropJson.ConversionSettings.ConversionFactors)) {
    conversionVariableUids.push(conversionFactor.VariableUID);
  }
  for (const uid in valuePropData) {
    map[uid] = {
      time: null,
      parents: [],
      children: [],
      variable: valuePropData[uid],
      queued: false,
      value: 0,
      unitValue: 0,
      valueDriver: valueDrivers[uid],
      priceComponent: getPriceComponent(uid, ourPriceComponents, competitorPriceComponents),
      name: valuePropData[uid].Name
    };
  }
  for (const uid in valuePropData) {
    const variable = valuePropData[uid];
    const variableNode = map[uid];
    for (const parameterCode of variable.ParameterCodes) {
      const parameterNode = map[parameterCode];
      variableNode.children.push(parameterNode);
      parameterNode.parents.push(variableNode);
    }
    if (variableNode.valueDriver || variableNode.priceComponent) {
      for (const conversionVariableUid of conversionVariableUids) {
        const conversionVariable = map[conversionVariableUid];
        variableNode.children.push(conversionVariable);
        conversionVariable.parents.push(variableNode);
      }
    }
  }
  return map;
}
function getPriceComponent(uid, ourPriceComponents, competitorPriceComponents) {
  const competitor = competitorPriceComponents[uid];
  if (competitor) {
    competitor.competitor = true;
    return competitor;
  }
  const ours = ourPriceComponents[uid];
  if (ours) {
    ours.competitor = false;
    return ours;
  }
  return null;
}
function getNodesWithoutParents(nodeMap) {
  return Object.values(nodeMap).filter((entry) => entry.parents.length === 0);
}
function recursiveAdd2(node, queue) {
  if (!node.queued) {
    node.queued = true;
    for (const child of node.children) {
      recursiveAdd2(child, queue);
    }
    queue.push(node);
  }
}

// src/index.ts
function createTree(valuePropJson, valueModelStore) {
  VariableProxy.defaultCurrencyPrecision = parseInt(valuePropJson.VarCurrencyPrecision);
  VariableProxy.defaultPercentPrecision = parseInt(valuePropJson.VarPercentPrecision);
  VariableProxy.defaultCountPrecision = parseInt(valuePropJson.VarCountPrecision);
  const piniaInitializer = new PiniaInitializer(valueModelStore);
  const { map, roots } = initTree(valuePropJson);
  const valueDrivers = roots.filter((item) => item.valueDriver);
  const ourPriceComponents = roots.filter((item) => item.priceComponent && item.priceComponent.competitor === false);
  const competitorPriceComponents = roots.filter((item) => item.priceComponent && item.priceComponent.competitor);
  const globalCalculator = new Calculator(map, valuePropJson, valueDrivers, ourPriceComponents, competitorPriceComponents);
  initCalculations(roots, globalCalculator);
  globalCalculator.calculateTotals();
  return piniaInitializer.initPinia(map, roots, valuePropJson, globalCalculator.getTotals());
}
//# sourceMappingURL=index.js.map